// eslint-disable-next-line @typescript-eslint/no-unused-vars -- they’re discarded
const noop = (..._args) => {
    // do nothing
};
export { noop };
